import { render, staticRenderFns } from "./CursoVersionView.vue?vue&type=template&id=5f32385f&"
import script from "./CursoVersionView.vue?vue&type=script&lang=js&"
export * from "./CursoVersionView.vue?vue&type=script&lang=js&"
import style0 from "./CursoVersionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports